export default __webpack_public_path__ + "static/media/90.f5121cd3.jpeg";